import token from "../serialize-token";
export default {
    white: token("#ffffff"),
    black: token("#000000"),
    purple: {
        "purple-100": token("#fbebff"),
        "purple-200": token("#ecc4ff"),
        "purple-300": token("#db9eff"),
        "purple-400": token("#c47af4"),
        "purple-500": token("#a95adc"),
        "purple-600": token("#994ccc"),
        "purple-700": token("#8a3fba"),
        "purple-800": token("#66278f"),
        "purple-900": token("#40155c"),
    },
    blue: {
        "blue-100": token("#d9f5fd"),
        "blue-200": token("#94dcf7"),
        "blue-300": token("#5cc1ee"),
        "blue-400": token("#31a2e3"),
        "blue-500": token("#1282d6"),
        "blue-600": token("#0672cb"),
        "blue-700": token("#0063b8"),
        "blue-800": token("#00468b"),
        "blue-900": token("#002a58"),
    },
    "light-blue": {
        "light-blue-100": token("#daf5fd"),
        "light-blue-200": token("#97dcf4"),
        "light-blue-300": token("#61c1eb"),
        "light-blue-400": token("#36a2e0"),
        "light-blue-500": token("#1885c3"),
        "light-blue-600": token("#0d76b2"),
        "light-blue-700": token("#0468a1"),
        "light-blue-800": token("#004a77"),
        "light-blue-900": token("#002d4b"),
    },
    green: {
        "green-100": token("#e9f5ce"),
        "green-200": token("#c0dd78"),
        "green-300": token("#9bc438"),
        "green-400": token("#7aa809"),
        "green-500": token("#5d8c00"),
        "green-600": token("#4f7d00"),
        "green-700": token("#436f00"),
        "green-800": token("#2c5000"),
        "green-900": token("#193100"),
    },
    yellow: {
        "yellow-100": token("#feefcb"),
        "yellow-200": token("#f5cd6f"),
        "yellow-300": token("#e6ac28"),
        "yellow-400": token("#ce8d00"),
        "yellow-500": token("#b36f00"),
        "yellow-600": token("#a36100"),
        "yellow-700": token("#925400"),
        "yellow-800": token("#6d3a00"),
        "yellow-900": token("#442200"),
    },
    orange: {
        "orange-100": token("#ffeed2"),
        "orange-200": token("#fec97a"),
        "orange-300": token("#f8a433"),
        "orange-400": token("#e67f01"),
        "orange-500": token("#c96100"),
        "orange-600": token("#b85200"),
        "orange-700": token("#a64600"),
        "orange-800": token("#7d2e00"),
        "orange-900": token("#4f1a00"),
    },
    red: {
        "red-100": token("#ffecee"),
        "red-200": token("#ffc3c9"),
        "red-300": token("#ff99a1"),
        "red-400": token("#fe6873"),
        "red-500": token("#e4424d"),
        "red-600": token("#d0353f"),
        "red-700": token("#bb2a33"),
        "red-800": token("#8c161f"),
        "red-900": token("#590a0f"),
    },
    berry: {
        "berry-100": token("#ffebf5"),
        "berry-200": token("#ffc0df"),
        "berry-300": token("#f69ac6"),
        "berry-400": token("#e574aa"),
        "berry-500": token("#cb548d"),
        "berry-600": token("#ba467d"),
        "berry-700": token("#a8396f"),
        "berry-800": token("#7f234f"),
        "berry-900": token("#511230"),
    },
    gray: {
        "gray-100": token("#f5f6f7"),
        "gray-200": token("#f0f0f0"),
        "gray-300": token("#e1e1e1"),
        "gray-400": token("#d2d2d2"),
        "gray-500": token("#b6b6b6"),
        "gray-600": token("#7e7e7e"),
        "gray-700": token("#6e6e6e"),
        "gray-800": token("#636363"),
        "gray-900": token("#0e0e0e"),
    },
    slate: {
        "slate-100": token("#ebf1f6"),
        "slate-200": token("#c5d4e3"),
        "slate-300": token("#a4b8cd"),
        "slate-400": token("#839db4"),
        "slate-500": token("#40586d"),
        "slate-600": token("#293b4d"),
        "slate-700": token("#1d2c3b"),
        "slate-800": token("#141d28"),
        "slate-900": token("#0a0e14"),
    },
};
